var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeedometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.6472C24 18.3647 22.8808 20.825 21.0711 22.606L22.8389 24.3457C25.1009 22.1195 26.5 19.0441 26.5 15.6472C26.5 8.85327 20.9035 3.3457 14 3.3457C7.09644 3.3457 1.5 8.85327 1.5 15.6472C1.5 19.0441 2.89911 22.1195 5.16116 24.3457L6.92894 22.606C5.11929 20.825 4 18.3647 4 15.6472C4 10.2121 8.47715 5.806 14 5.806C19.5229 5.806 24 10.2121 24 15.6472ZM18.1163 9.85685L12.4913 15.3926L14.259 17.1322L19.884 11.5965L18.1163 9.85685Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/speedometer.9bb1a51928d31ec9cfee7dae9cfe8757.svg";
export { ForwardRef as ReactComponent };